import type { FormHTMLAttributes } from "react";
import { preventEnterSubmit } from "@/utils/forms";

type FormProps = FormHTMLAttributes<HTMLFormElement>;

/**
 * Drop-in replacement for <form> that also applies preventEnterSubmit, so
 * every multi-field form in the app gets it automatically instead of each
 * one having to remember to wire up `onKeyDown={preventEnterSubmit}` itself.
 */
export function Form({ onKeyDown, noValidate = true, ...props }: FormProps) {
  return (
    <form
      {...props}
      noValidate={noValidate}
      onKeyDown={(event) => {
        preventEnterSubmit(event);
        onKeyDown?.(event);
      }}
    />
  );
}
